import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { modal, notification } from 'redux/modules/app'
import { push } from 'connected-react-router'
import { AssessorReport } from 'containers/forms/assessor'
import {
  AssessorParticipantInfo,
  AssessorAJParticipantTable,
  AssessorAJParticipantActivity
} from 'components/sections/assessor'
import { AuthCodeInvalid } from 'components/misc'
import { HeaderPlain, NarrowContainer, Section } from 'components/layout'
import { meta } from 'helpers/decorators'
import { apiAjEvents, apiCodeLists } from 'helpers/decorators/api'
import { AJ_EVENT_TYPES } from 'constants/enums'
import { parseAuthCode } from 'utils/authCode'
import appConfig from 'config'

@injectIntl
@meta({
  title: 'Assessment'
})
@connect(null, { modal, notification, push })
@apiCodeLists(['titles'], { public: true })
@apiAjEvents({
  publicDetail: true
})
class AssessorAjParticipantEventAssessment extends Component {
  static propTypes = {
    modal: PropTypes.func.isRequired,
    notification: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    sendAjParticipantEventAssessorReport: PropTypes.func.isRequired,
    getPublicAjEventAssessmentRequests: PropTypes.func.isRequired,
    setMetaTitle: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    ajEvents: PropTypes.object.isRequired,
    codeLists: PropTypes.object.isRequired
  }

  state = {
    error: null
  }

  componentDidMount() {
    const { ajEvents } = this.props

    get(
      ajEvents,
      'eventParticipants.ajParticipantEventAssessmentRequestActionId'
    ) &&
      this.handleAjEventAssessment(
        get(ajEvents, 'eventParticipants.id'),
        get(
          ajEvents,
          'eventParticipants.ajParticipantEventAssessmentRequestActionId'
        )
      )
  }

  componentWillReceiveProps(nextProps) {
    const { ajEvents } = this.props

    if (
      !get(ajEvents, 'error.userMessage') &&
      get(nextProps.ajEvents, 'error.userMessage')
    ) {
      this.setState({
        error: get(nextProps.ajEvents, 'error.userMessage')
      })
    }

    if (
      get(
        ajEvents,
        'eventParticipants.ajParticipantEventAssessmentRequestActionId'
      ) !==
      get(
        nextProps.ajEvents,
        'eventParticipants.ajParticipantEventAssessmentRequestActionId'
      )
    ) {
      this.handleAjEventAssessment(
        get(nextProps.ajEvents, 'eventParticipants.id'),
        get(
          nextProps.ajEvents,
          'eventParticipants.ajParticipantEventAssessmentRequestActionId'
        )
      )
    }

    this.handleSetMetaTitle(nextProps)
  }

  handleAjEventAssessment = (activityId, actionId) => {
    actionId &&
      this.props.getPublicAjEventAssessmentRequests(activityId, actionId)
  }

  handleSetMetaTitle = nextProps => {
    const { ajEvents, intl } = this.props

    if (
      !get(ajEvents, 'eventParticipants.ajEvent.ajEventCategory.value') &&
      get(nextProps.ajEvents, 'eventParticipants.ajEvent.ajEventCategory.value')
    ) {
      const isSupervisor =
        get(
          nextProps.ajEvents,
          'eventParticipants.ajEvent.ajEventCategory.value'
        ) === AJ_EVENT_TYPES.practice.id

      const role = isSupervisor
        ? intl.formatMessage({
            id: 'global.supervisor',
            defaultMessage: 'supervisor'
          })
        : intl.formatMessage({
            id: 'global.assessor',
            defaultMessage: 'Assessor'
          })

      this.props.setMetaTitle(
        intl.formatMessage(
          {
            id: 'label.assessment_with_role',
            defaultMessage: '{role} assessment'
          },
          {
            role
          }
        )
      )
    }
  }

  assessorReportSubmit = data => {
   const authCode = parseAuthCode(this.props)

    this.props
      .sendAjParticipantEventAssessorReport(
        get(this.props, 'params.ajId'),
        authCode,
        data
      )
      .then(() => {
        this.props.push(`${appConfig.publicPath}/assessor-assessment/success`)
      })
      .catch(({ body = {} }) => {
        console.debug('error', body.userMessage)
        body.userMessage && this.props.notification(body.userMessage, 'error')
      })
  }

  assessorReportReject = data => {
    const authCode = parseAuthCode(this.props)

    this.props.sendAjParticipantEventAssessorReport(
      get(this.props, 'params.ajId'),
        authCode,
      {
        note: data.note,
        approved: false,
        assessorReportDetail: {}
      }
    )
  }

  render() {
    const { ajEvents, codeLists } = this.props
    const { error } = this.state
    const isSupervisor =
      get(ajEvents, 'eventParticipants.ajEvent.ajEventCategory.value') ===
      AJ_EVENT_TYPES.practice.id

    return (
      <div>
        <HeaderPlain />
        <Section loading={ajEvents.loading}>
          <NarrowContainer>
            {error && <AuthCodeInvalid />}
            {ajEvents.loaded &&
              <div className="content">
                <AssessorParticipantInfo activity={ajEvents.eventParticipants}>
                  <AssessorAJParticipantTable
                    eventParticipants={ajEvents.eventParticipants}
                  />
                </AssessorParticipantInfo>

                <AssessorAJParticipantActivity
                  eventParticipants={ajEvents.eventParticipants}
                  assessment={ajEvents.assessment}
                />
                <AssessorReport
                  data={get(ajEvents, 'eventParticipants.ajEvent')}
                  sending={ajEvents.sending}
                  sent={ajEvents.reportSent}
                  onSubmit={this.assessorReportSubmit}
                  onReject={this.assessorReportReject}
                  codeLists={codeLists}
                  modal={this.props.modal}
                  supervisor={isSupervisor}
                />
              </div>}
          </NarrowContainer>
        </Section>
      </div>
    )
  }
}

export default AssessorAjParticipantEventAssessment
